import React from 'react';
import { CarFront, Wrench, Car, Truck, DoorOpen, PhoneCall, ArrowRight } from 'lucide-react';
export function Services() {
  const services = [{
    icon: CarFront,
    title: 'Emergency Windshield Replacement',
    copy: "For cracked, shattered or unsafe windshields, Kosin's Glass provides professional windshield replacement with certified technicians and quality glass options."
  }, {
    icon: Wrench,
    title: 'Broken Windshield Repair Today',
    copy: "Small chips may be repairable before they spread. Kosin's Glass can inspect the damage and explain whether chip repair or replacement is safer."
  }, {
    icon: Car,
    title: 'Shattered Side Window Replacement',
    copy: 'Driver side, passenger side and power window glass replacement for broken or shattered side windows.'
  }, {
    icon: CarFront,
    title: 'Rear Window Replacement',
    copy: 'Replacement for broken rear vehicle glass, back windows, truck rear glass and other damaged rear window glass.'
  }, {
    icon: DoorOpen,
    title: 'Car Door & Quarter Glass',
    copy: 'Replacement for car door glass, quarter glass, vent glass and other urgent vehicle glass damage.'
  }, {
    icon: Truck,
    title: 'Truck, Van, Fleet & Semi Glass',
    copy: 'Urgent glass repair and replacement options for trucks, vans, commercial vehicles, fleets and semi trucks.'
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-248">
      <div className="max-w-7xl mx-auto" data-id="element-249">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-250">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-251">
            Emergency{' '}
            <span className="text-brand-red" data-id="element-252">Auto Glass Services</span> for
            Broken Vehicle Glass
          </h2>
          <p className="text-lg text-slate-600" data-id="element-253">
            When vehicle glass breaks, you need clear answers fast. Kosin's
            Glass can inspect the damage, explain whether repair or replacement
            is needed, and help schedule the fastest available option.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-254">
          {services.map((service, i) => <div key={i} className="bg-white rounded-xl p-6 border border-slate-200 hover:border-brand-red/40 hover:shadow-md transition-all" data-id="element-255">
              <div className="w-12 h-12 bg-brand-redLight rounded-lg flex items-center justify-center mb-5" data-id="element-256">
                <service.icon className="w-6 h-6 text-brand-red" data-id="element-257" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-258">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-259">{service.copy}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-260">
          <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-261">
            <PhoneCall className="w-5 h-5" data-id="element-262" />
            Check Today's Auto Glass Openings
            <ArrowRight className="w-4 h-4" data-id="element-263" />
          </a>
        </div>
      </div>
    </section>;
}